"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieAnonymousId = void 0;
var browser_cookies_1 = __importDefault(require("browser-cookies"));
var non_secure_1 = __importDefault(require("nanoid/non-secure"));
var isDoNotTrackEnabled_1 = require("./utils/isDoNotTrackEnabled");
/**
 * Creates or retrieves an anonymous id for the user, backed by
 * cookies for persistence across sessions. If no configuration
 * is supplied, defaults to a cookie named "roo_anonymous_id"
 * which expires in 1 year from now.
 *
 * @param config cookie options (optional)
 */
function getCookieAnonymousId(config) {
    var _a = config || {}, _b = _a.name, name = _b === void 0 ? 'roo_anonymous_id' : _b, _c = _a.lifetime, lifetime = _c === void 0 ? 31536000000 : _c;
    if ((0, isDoNotTrackEnabled_1.isDoNotTrackEnabled)()) {
        return 'do-not-track';
    }
    var existing = browser_cookies_1.default.get(name);
    if (existing) {
        return existing;
    }
    var generated = (0, non_secure_1.default)();
    browser_cookies_1.default.set(name, generated, {
        samesite: 'Strict',
        domain: window.location.hostname,
        expires: new Date(Date.now() + lifetime),
    });
    return generated;
}
exports.getCookieAnonymousId = getCookieAnonymousId;
